import React from 'react';
import { Outlet } from 'react-router-dom';
import SideBar from '../components/Layouts/SideBar';
import Header from '../components/Layouts/Header';

const PanelLayout = () => {
    return (
        <div>
          <SideBar />
          
        </div>
    );
}

export default PanelLayout